var map = {
	"./amazon-echo.svg": 47345,
	"./apple.svg": 58885,
	"./code.svg": 59023,
	"./deezer.svg": 57675,
	"./google-home.svg": 4719,
	"./google-play.svg": 48030,
	"./iheart-radio.svg": 14156,
	"./pandora.svg": 64979,
	"./pocketcasts.svg": 28283,
	"./radio-com.svg": 36998,
	"./radio-public.svg": 89799,
	"./rss-feed.svg": 61849,
	"./spotify.svg": 6329,
	"./stitcher.svg": 17323,
	"./tune-in.svg": 36705,
	"./wordpress.svg": 53047,
	"./youtube.svg": 13653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74968;